import { useAvailableComponents } from '../../../hooks/useAvailableComponents'
import { MemberIconFromCommitmentVersion } from './MemberIconFromCommitmentVersion'
import { MemberIconFromLegalEntity } from './MemberIconFromLegalEntity'

export const MemberIcon = () => {
  const { isUsingLegalEntity } = useAvailableComponents()
  return isUsingLegalEntity ? (
    <MemberIconFromLegalEntity />
  ) : (
    <MemberIconFromCommitmentVersion />
  )
}
